const theme = {
  colors: {
    primary: "#1E88E5",
    background: "#E3F2FD",

    primaryLight: "#42A5F5",
    primaryDark: "#1565C0",

    text: "#212121",
  },

  // sizes: {},

  shadows: {
    main: "0 4px 6px rgba(0, 0, 0, 0.1)",
    hover: "0 6px 8px rgba(0, 0, 0, 0.15)",
  },
};

export default theme;
